import create from "zustand";
import { persist } from "zustand/middleware";
import createUserSlice from "./createUserSlice";

const useStore = create(
  persist(
    (set, get) => ({
      ...createUserSlice(set, get),
      clearStore: () => set({}, true),
    }),
    { name: "merchant-web" }
  )
);

export default useStore;
